import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Image from '../../components/AppImage';
import LoginForm from './components/LoginForm';
import SystemStatusIndicator from './components/SystemStatusIndicator';
import SecurityFeatures from './components/SecurityFeatures';
import CompanyBranding from './components/CompanyBranding';

const AuthenticationAndRoleAssignment = () => {
  const [sessionInfo, setSessionInfo] = useState(null);

  const handleLoginSuccess = (userInfo) => {
    setSessionInfo({
      ...userInfo,
      loginTime: new Date(),
      sessionTimeout: 30 * 60 * 1000
    });
  };

  return (
    <>
      <Helmet>
        <title>تسجيل الدخول - نظام إدارة العقارات</title>
        <meta name="description" content="تسجيل الدخول إلى نظام إدارة العقارات - منصة متكاملة لإدارة العقارات والعملاء والعقود" />
      </Helmet>

      <div className="min-h-screen bg-background relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <Image
            src="/assets/images/Apropapplogo-1768301171635.jpg"
            alt="Property Applications Logo watermark background"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-background to-secondary/5" />

        <div className="relative z-10 min-h-screen flex items-center justify-center p-4 md:p-6 lg:p-8">
          <div className="w-full max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-center">
              <div className="order-2 lg:order-1 space-y-6">
                <div className="hidden lg:block">
                  <CompanyBranding />
                </div>

                <div className="lg:hidden">
                  <div className="flex flex-col items-center text-center space-y-4 mb-6">
                    <img
                      src="/assets/images/Apropapplogo-1768301171635.jpg"
                      alt="Property Applications Logo"
                      className="h-12 object-contain"
                    />
                  </div>
                </div>

                <div className="hidden lg:block">
                  <SecurityFeatures />
                </div>
              </div>

              <div className="order-1 lg:order-2 space-y-4 md:space-y-6">
                <div className="bg-card border border-border rounded-2xl shadow-warm-xl p-6 md:p-8">
                  <div className="mb-6 md:mb-8">
                    <h2 className="text-xl md:text-2xl font-heading font-bold text-white mb-2">
                      تسجيل الدخول
                    </h2>
                    <p className="text-sm md:text-base text-white/70 font-caption">
                      أدخل بيانات الدخول الخاصة بك للوصول إلى النظام
                    </p>
                  </div>

                  <LoginForm onLoginSuccess={handleLoginSuccess} />

                  <div className="mt-6 pt-6 border-t border-border">
                    <div className="flex items-center justify-center gap-2 text-sm text-white/70 font-caption">
                      <span>بحاجة إلى مساعدة؟</span>
                      <a 
                        href="mailto:support@realestate.sa?subject=طلب دعم فني - نظام إدارة العقارات"
                        className="text-primary hover:text-primary/80 font-medium transition-colors"
                      >
                        اتصل بالدعم الفني
                      </a>
                    </div>
                  </div>
                </div>

                <SystemStatusIndicator />

                <div className="lg:hidden">
                  <SecurityFeatures />
                </div>
              </div>
            </div>

            <div className="mt-8 text-center">
              <p className="text-xs md:text-sm text-white/60 font-caption">
                محمي بواسطة تشفير SSL/TLS • متوافق مع GDPR • معتمد ISO 27001
              </p>
            </div>

            {/* Powered By Footer */}
            <div className="mt-6 flex items-center justify-center gap-2">
              <span className="text-xs text-white/60 font-caption">Powered by</span>
              <Image
                src="/assets/images/ky-digital-solutions-favicon-1768297877804.png"
                alt="KY Digital Solutions logo"
                className="h-5 w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthenticationAndRoleAssignment;